<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree">
  <!-- LEAF NODES -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [matTreeNodePaddingIndent]="16">
    <li [style.margin-left]="'32px'">
      <div id="node-container" class="d-flex align-items-center justify-content-between">
        <ng-container [ngTemplateOutlet]="nodeText" [ngTemplateOutletContext]="{ node }"> </ng-container>
        <ng-container [ngTemplateOutlet]="actionButtons" [ngTemplateOutletContext]="{ node }"> </ng-container>
      </div>
    </li>
  </mat-tree-node>
  <!-- EXPANDABLE NODES -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [matTreeNodePaddingIndent]="16">
    <li>
      <div id="node-container" [attr.id]="node.obj_urn" class="d-flex align-items-center justify-content-between">
        <div
          class="d-flex align-items-center justify-content-start pointer"
          (click)="clickToogleButton(node, treeControl)"
        >
          <ng-container [ngTemplateOutlet]="toggleButton" [ngTemplateOutletContext]="{ node }"> </ng-container>
          <ng-container [ngTemplateOutlet]="nodeText" [ngTemplateOutletContext]="{ node }"> </ng-container>
        </div>
        <ng-container [ngTemplateOutlet]="actionButtons" [ngTemplateOutletContext]="{ node }"> </ng-container>
      </div>
      <ul [@slideVertical]="treeControl.isExpanded(node) ? 'show' : null">
        <ng-container matTreeNodeOutlet></ng-container>
      </ul>
    </li>
  </mat-nested-tree-node>
</mat-tree>
<div *ngIf="isEmpty && emptyMessage" class="px-3 py-2">{{ emptyMessage }}</div>
<div *ngIf="hasError && errorMessage" class="px-3 py-2 d-flex align-items-center gap-2 text-danger">
  <mat-icon>error_outline</mat-icon>
  <span>{{ errorMessage }}</span>
</div>
<!-- TOGGLE BUTTON -->
<ng-template #toggleButton let-node="node">
  <button mat-icon-button [attr.aria-label]="'toggle ' + node.name">
    <mat-icon class="mat-icon-rtl-mirror">
      {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
    </mat-icon>
  </button>
</ng-template>
<!-- TEXT -->
<ng-template #nodeText let-node="node">
  <div id="node-text-container" class="d-flex flex-column align-items-start">
    <span>
      {{ node.obj_desc }}
    </span>
    <span id="type">
      {{ node.obj_type }}
    </span>
  </div>
</ng-template>
<!-- ACTION BUTTONS -->
<ng-template #actionButtons let-node="node">
  <button mat-icon-button id="menu-button" [matMenuTriggerFor]="menu" *ngIf="node.obj_urn">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button
      mat-menu-item
      *ngIf="!node.is_root && _selectable && isAssetSelectableBasedOnType(node)"
      (click)="handleButtonAction('select', node)"
      matTooltip="Seleziona l'elemento"
      matTooltipPosition="right"
    >
      <mat-icon class="menu-icon me-1" color="accent">check</mat-icon>
      <span>Seleziona</span>
    </button>
    <button
      mat-menu-item
      *ngIf="_canShowOnMap"
      (click)="handleButtonAction('go_to', node)"
      matTooltip="Posiziona oggetto su mappa"
      matTooltipPosition="right"
    >
      <mat-icon class="menu-icon me-1" color="accent">zoom_in_fit</mat-icon>
      <span> Mostra sulla mappa </span>
    </button>
    <button
      mat-menu-item
      (click)="handleButtonAction('copy', node)"
      matTooltip="Copia negli appunti"
      matTooltipPosition="right"
    >
      <mat-icon class="menu-icon me-1" color="accent">content_copy</mat-icon>
      <span>Copia</span>
    </button>
    <button
      mat-menu-item
      *ngIf="!node.is_root && _canGoToDetail"
      (click)="handleButtonAction('detail', node)"
      matTooltip="Mostra il dettaglio dell'oggetto"
      matTooltipPosition="right"
    >
      <mat-icon class="menu-icon me-1" color="accent">info_outline</mat-icon>
      <span>Dettaglio</span>
    </button>
    <button
      mat-menu-item
      *ngIf="_canStartOtdr && isAssetTypesAllowedToStartOtdr(node)"
      (click)="handleButtonAction('otdr', node)"
      matTooltip="Vai al pannello OTDR"
      matTooltipPosition="right"
    >
      <mat-icon class="menu-icon me-1" color="accent">usb_off</mat-icon>
      <span>Otdr</span>
    </button>
    <ng-container *appCustomer="[customerEnum.Fastweb]">
      <button
        mat-menu-item
        [matMenuTriggerFor]="menuExport"
        *ngIf="_canExport || (_canExportConnectivity && node.is_root)"
      >
        <mat-icon class="me-1" color="accent">download</mat-icon>
        <span>File</span>
      </button>
      <button
        mat-menu-item
        *ngIf="isAssetAllowedToViewRaccordi(node)"
        (click)="handleButtonAction('raccordi', node)"
        matTooltip="Visualizzazione Gestione Raccordi"
        matTooltipPosition="right"
      >
        <mat-icon class="me-1" color="accent">cable</mat-icon>
        <span>Gestione Raccordi</span>
      </button>
      <mat-menu #menuExport="matMenu">
        <button
          mat-menu-item
          (click)="handleButtonAction('csv_struttura', node)"
          matTooltip="Esporta la struttura in csv"
          matTooltipPosition="right"
        >
          <mat-icon class="me-1" color="accent">insert_drive_file</mat-icon>
          <span>Struttura CSV</span>
        </button>
        <button
          *ngIf="_canExport"
          mat-menu-item
          (click)="handleButtonAction('html_struttura', node)"
          matTooltip="Esporta la struttura in html"
          matTooltipPosition="right"
        >
          <mat-icon class="me-1" color="accent">insert_drive_file</mat-icon>
          <span>Struttura HTML</span>
        </button>
        <button
          *ngIf="node.is_root && _canExportConnectivity"
          mat-menu-item
          (click)="handleButtonAction('csv_connectivity', node)"
          matTooltip="Esporta la struttura in csv"
          matTooltipPosition="right"
        >
          <mat-icon class="me-1" color="accent">insert_drive_file</mat-icon>
          <span>Connectivity CSV</span>
        </button>
        <button
          mat-menu-item
          *ngIf="isAssetAllowedToDownloadKmzCircuiti(node)"
          (click)="handleButtonAction('kmz_circuiti', node)"
          matTooltip="Esporta il percorso (.kmz)"
          matTooltipPosition="right"
        >
          <mat-icon class="me-1" color="accent">insert_drive_file</mat-icon>
          <span>Percorso KMZ</span>
        </button>
        <button
          mat-menu-item
          *ngIf="isAssetAllowedToDownloadCsvPercorso(node)"
          (click)="handleButtonAction('csv_percorso', node)"
          matTooltip="Export percorso Seg. Ottico"
          matTooltipPosition="right"
        >
          <mat-icon class="me-1" color="accent">insert_drive_file</mat-icon>
          <span>Seg.Ottico CSV</span>
        </button>
      </mat-menu>
      <button
        mat-menu-item
        [matMenuTriggerFor]="menuTracciatoIRU"
        *ngIf="isAssetTracciatoIRU(node)"
      >
        <mat-icon class="me-1" color="accent">route</mat-icon>
        <span>Tracciato IRU</span>
      </button>
      <mat-menu #menuTracciatoIRU="matMenu">
        <button
          mat-menu-item
          (click)="handleButtonAction('download_kmz_tracciato_olo', node)"
          matTooltip="Export KMZ Tracciato OLO"
          matTooltipPosition="right"
          >
          <mat-icon class="me-1" color="accent">insert_drive_file</mat-icon>
          <span>KMZ Tracciato OLO</span>
        </button>
        <button
          mat-menu-item
          (click)="handleButtonAction('download_pdf_tracciato_olo', node)"
          matTooltip="Verbale OLO"
          matTooltipPosition="right"
          >
          <mat-icon class="me-1" color="accent">insert_drive_file</mat-icon>
          <span>Verbale OLO</span>
        </button>
      </mat-menu>
    </ng-container>
  </mat-menu>
</ng-template>
